import { Alert } from "antd";
import { FormattedMessage } from "react-intl";

import "./index.css";

const CustomerAlert = ({ show, textId, defautTextMessage }) =>
  show ? (
    <Alert
      type="error"
      className="alert-margin"
      message={
        <FormattedMessage id={textId} defaultMessage={defautTextMessage} />
      }
    />
  ) : (
    <></>
  );

export default CustomerAlert;
